import {Action} from '../../../../common/types/common';
import {MediciValidationDTO} from '../../creditoReal/types/mx/epics';

export const SET_MEDICI_VALIDATION_DATA_STATE_ACTION: Action = {
    name: 'SET_MEDICI_VALIDATION_DATA_STATE_ACTION',
    action: (mediciValidation: MediciValidationDTO) => ({
        mediciValidation,
        type: SET_MEDICI_VALIDATION_DATA_STATE_ACTION.name
    })
};

export const SEND_MEDICI_VALIDATION_EMAIL_ACTION: Action = {
    name: 'SEND_MEDICI_VALIDATION_EMAIL_ACTION',
    action: () => ({
        type: SEND_MEDICI_VALIDATION_EMAIL_ACTION.name
    })
};

export const MEDICI_VALIDATION_EMAIL_SENT_ACTION: Action = {
    name: 'MEDICI_VALIDATION_EMAIL_SENT_ACTION',
    action: () => ({
        type: MEDICI_VALIDATION_EMAIL_SENT_ACTION.name
    })
};
